import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "slider-indicator__path" }

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SliderIndicator',
  props: {
    slides: null,
    currentSlide: null
  },
  setup(__props: any) {

const props = __props as {
  slides: number;
  currentSlide: number;
}



const indicatorStyle = computed(() => {
  return {
    width: `${100 / props.slides}%`,
    left: `${(100 / props.slides) * (props.currentSlide - 1)}%`,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "slider-indicator",
      style: _normalizeStyle(_unref(indicatorStyle))
    }, null, 4)
  ]))
}
}

})